import { createSelector } from "@ngrx/store";
import { appState } from "src/app/shared/interfaces/appState.interface";

export const selectPriceState = (state: appState) => state.price;

export const selectAllPrices = createSelector(
  selectPriceState,
  (priceState) => priceState.priceBoard.all
);